import React from 'react';

export default function ExportSalesOrders() {
	return (
		<>
			<div className="comp-heading">
				<div className="row">
					<div className="col-lg-4">
						<label>Export Sales Orders</label>
					</div>
				</div>
			</div>
			<br />
			ExportSalesOrders
		</>
	);
}
